import dayjs from 'dayjs'
import customFormat from 'dayjs/plugin/customParseFormat'

import './common/api/project-api'
import './common/utils/localisation'
// Any IE polyfills etc
import '@hoxtonmix/setup/polyfill-common'

dayjs.extend(customFormat)
